import type {StyleFunctionProps} from '@chakra-ui/styled-system';
import {defineCssVars, defineStyleConfig} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

export const {
  fontSize: $fontSize,
  color: $color,
  fontWeight: $fontWeight,
  gap: $gap,
} = defineCssVars(`paginationCounter`, [`fontSize`, `color`, `fontWeight`, `gap`]);

export const counterCssVars = ({colorMode}: StyleFunctionProps) => ({
  [$fontSize.variable]: `sm`,
  [$color.variable]: mode(`colors.gray.600`, `colors.whiteAlpha.800`)({colorMode}),
  [$fontWeight.variable]: `inherit`,
  [$gap.variable]: `space.12`,
});

export const counterStyle = defineStyleConfig({
  baseStyle: {
    fontSize: `sm`,
    color: $color.reference,
    fontWeight: $fontWeight.reference,
    display: `flex`,
    alignItems: `center`,
    gap: $gap.reference,
  },
  sizes: {},
});
